module.exports = __webpack_public_path__ + "media/sol.29467b49.mp4";